import { render } from "./ContactUs.vue?vue&type=template&id=2af8f499"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=2af8f499&lang=css"

import exportComponent from "/home/runcloud1user/webapps/ismail-khayat-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__